// В.1.f-1: «временные» keyword'ы со сроком жизни до конца указанного хода.
//
// Использование: Перегруппировка (Глобал) даёт юниту FRENZY на текущий ход.
// В отличие от derivedKeywords (триггеры по линии — пересчитываются на лету)
// и persistentKeywords (от Стимулятора — навсегда), transient очищается в
// конце хода через endOfTurnCleanup → cleanupTransientKeywords.
//
// Структура:
//   card.transientKeywords: [{ kw, sourceId, expireAfterTurn }]
//
// При очистке: если у kw больше нет ни одного источника (base/persistent/
// derived/Mod/другой transient), снимаем из card.keywords.

import { hasKeyword, removeKeyword } from '../keywords.js';

export function addTransientKeyword(card, kw, sourceId, expireAfterTurn) {
  if (!card) return;
  if (!Array.isArray(card.transientKeywords)) card.transientKeywords = [];
  card.transientKeywords.push({ kw, sourceId, expireAfterTurn });
  if (!Array.isArray(card.keywords)) card.keywords = [];
  if (!hasKeyword(card, kw)) card.keywords.push(kw);
}

// Проверка: есть ли kw из НЕ-transient источников у этой карты.
function hasKwFromNonTransientSources(card, kw) {
  if (Array.isArray(card.template?.keywords) && card.template.keywords.includes(kw)) return true;
  if (Array.isArray(card.persistentKeywords) && card.persistentKeywords.includes(kw)) return true;
  if (Array.isArray(card.derivedKeywords)    && card.derivedKeywords.includes(kw))    return true;
  for (const m of (card.modifications || [])) {
    if (Array.isArray(m.applied?.keywordsAdded) && m.applied.keywordsAdded.includes(kw)) return true;
  }
  return false;
}

// Вызывается из endOfTurnCleanup. Удаляет истёкшие записи + снимает kw из
// card.keywords, если ни один источник его больше не даёт.
export function cleanupTransientKeywords(card, currentTurn) {
  if (!Array.isArray(card.transientKeywords) || card.transientKeywords.length === 0) return;
  const surviving = [];
  const expiredKws = new Set();
  for (const t of card.transientKeywords) {
    if (currentTurn < t.expireAfterTurn) {
      surviving.push(t);
    } else {
      expiredKws.add(t.kw);
    }
  }
  card.transientKeywords = surviving;
  for (const kw of expiredKws) {
    // Другие источники этого же kw?
    if (hasKwFromNonTransientSources(card, kw)) continue;
    if (surviving.some(t => t.kw === kw)) continue;
    removeKeyword(card, kw);
  }
}
